import React from 'react'
import { Box, Display, FlexDirection } from '@gousto-internal/citrus-react'

import type { CollectionUUID, ParentCategory as ParentCategoryType } from '@library/menu-service'
import { CategoryTile } from '../CategoryTile/CategoryTile'
import { ParentCategoryHeader } from '../ParentCategoryHeader/ParentCategoryHeader'

export type ParentCategoryProps = {
  id: CollectionUUID
  categories: ParentCategoryType['categories']
  description?: string
  isLinkable: boolean
  type: 'generic' | 'promoted'
  name: string
  recipeCount: number
  onCategoryClick: (categoryId: CollectionUUID) => void
}

export const ParentCategory = ({
  id,
  categories,
  description,
  isLinkable,
  type,
  name,
  recipeCount,
  onCategoryClick,
}: ParentCategoryProps) => {
  return (
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={3}>
      <ParentCategoryHeader
        id={id}
        description={description}
        isLinkable={isLinkable}
        type={type}
        name={name}
        recipeCount={recipeCount}
        onCategoryClick={onCategoryClick}
      />
      <Box display={Display.Flex} flexDirection={FlexDirection.Row} gap={6} wrap>
        {categories.map(({ id: categoryId, shortTitle, recipeCount, image }) => (
          <CategoryTile
            key={categoryId}
            title={shortTitle}
            imageCrops={image?.crops}
            recipeCount={recipeCount}
            onClick={() => onCategoryClick(categoryId)}
          />
        ))}
      </Box>
    </Box>
  )
}
